var _defs, _path, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransportation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b7b7b7;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.59,11.47v-.85H4.42l0,.84a3.86,3.86,0,0,1-.9,0c-.15,0-.38-.24-.38-.38,0-1.46,0-2.93,0-4.48l-.67-.5.47-.71.72.45c.29-.63.6-1.23.87-1.84a.67.67,0,0,1,.71-.47c1.59,0,3.17,0,4.75,0a.67.67,0,0,1,.71.47c.24.59.51,1.18.78,1.81l.7-.41.47.7-.68.49c0,1.52,0,3,0,4.46,0,.15-.27.36-.46.42A3.24,3.24,0,0,1,10.59,11.47ZM4,7.08V9.66h7V7.08Zm.44-1h6.15c-.21-.5-.38-1-.61-1.4a.66.66,0,0,0-.47-.31c-1.31,0-2.62,0-3.92,0a.56.56,0,0,0-.41.17C4.92,5.07,4.69,5.59,4.44,6.13Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 6.24,
    cy: 8.37,
    r: 0.42
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.54,
    cy: 8.37,
    r: 0.42
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportation);
export default __webpack_public_path__ + "static/media/transportation.02820a28f29bb25317c1abdf7ffd7ef9.svg";
export { ForwardRef as ReactComponent };